// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: rest/annotations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "rest";

export enum Service {
  SERVICE_UNSPECIFIED = 0,
  SERVICE_BRIG = 1,
  SERVICE_CONFIGD = 2,
  SERVICE_SEXTANT = 3,
  SERVICE_BILGE = 4,
  SERVICE_KRANG = 5,
  SERVICE_RUDDER = 6,
  SERVICE_FRED = 7,
  SERVICE_MIZZEN = 8,
  SERVICE_ONESHOT = 9,
  SERVICE_DRAKE = 10,
  SERVICE_DESIGN = 11,
  SERVICE_TSIMLITE = 12,
  UNRECOGNIZED = -1,
}

export function serviceFromJSON(object: any): Service {
  switch (object) {
    case 0:
    case "SERVICE_UNSPECIFIED":
      return Service.SERVICE_UNSPECIFIED;
    case 1:
    case "SERVICE_BRIG":
      return Service.SERVICE_BRIG;
    case 2:
    case "SERVICE_CONFIGD":
      return Service.SERVICE_CONFIGD;
    case 3:
    case "SERVICE_SEXTANT":
      return Service.SERVICE_SEXTANT;
    case 4:
    case "SERVICE_BILGE":
      return Service.SERVICE_BILGE;
    case 5:
    case "SERVICE_KRANG":
      return Service.SERVICE_KRANG;
    case 6:
    case "SERVICE_RUDDER":
      return Service.SERVICE_RUDDER;
    case 7:
    case "SERVICE_FRED":
      return Service.SERVICE_FRED;
    case 8:
    case "SERVICE_MIZZEN":
      return Service.SERVICE_MIZZEN;
    case 9:
    case "SERVICE_ONESHOT":
      return Service.SERVICE_ONESHOT;
    case 10:
    case "SERVICE_DRAKE":
      return Service.SERVICE_DRAKE;
    case 11:
    case "SERVICE_DESIGN":
      return Service.SERVICE_DESIGN;
    case 12:
    case "SERVICE_TSIMLITE":
      return Service.SERVICE_TSIMLITE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Service.UNRECOGNIZED;
  }
}

export function serviceToJSON(object: Service): string {
  switch (object) {
    case Service.SERVICE_UNSPECIFIED:
      return "SERVICE_UNSPECIFIED";
    case Service.SERVICE_BRIG:
      return "SERVICE_BRIG";
    case Service.SERVICE_CONFIGD:
      return "SERVICE_CONFIGD";
    case Service.SERVICE_SEXTANT:
      return "SERVICE_SEXTANT";
    case Service.SERVICE_BILGE:
      return "SERVICE_BILGE";
    case Service.SERVICE_KRANG:
      return "SERVICE_KRANG";
    case Service.SERVICE_RUDDER:
      return "SERVICE_RUDDER";
    case Service.SERVICE_FRED:
      return "SERVICE_FRED";
    case Service.SERVICE_MIZZEN:
      return "SERVICE_MIZZEN";
    case Service.SERVICE_ONESHOT:
      return "SERVICE_ONESHOT";
    case Service.SERVICE_DRAKE:
      return "SERVICE_DRAKE";
    case Service.SERVICE_DESIGN:
      return "SERVICE_DESIGN";
    case Service.SERVICE_TSIMLITE:
      return "SERVICE_TSIMLITE";
    case Service.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * TokenPermission defines a piece of functionality where a Bearer Token can be used.
 * Permissions are optional.
 *
 * If defined, then a token can only be used where an rpc defining an endpoint
 * also lists out its required permissions.
 *
 * If not defined, then the token can be used anywhere except where permissions are explicity
 * listed on the rpc.
 */
export enum TokenPermission {
  PERMISSION_UNSPECIFIED = 0,
  /** PERMISSION_ONBOARD_DEVICE - Restrict a token to onboarding devices only. */
  PERMISSION_ONBOARD_DEVICE = 1,
  /** PERMISSION_MCP - Restrict a token to test the MCP endpoint used for AI Canvas integrarion. */
  PERMISSION_MCP = 2,
  /** PERMISSION_TEST - A test permission for integation tests. */
  PERMISSION_TEST = 100,
  UNRECOGNIZED = -1,
}

export function tokenPermissionFromJSON(object: any): TokenPermission {
  switch (object) {
    case 0:
    case "PERMISSION_UNSPECIFIED":
      return TokenPermission.PERMISSION_UNSPECIFIED;
    case 1:
    case "PERMISSION_ONBOARD_DEVICE":
      return TokenPermission.PERMISSION_ONBOARD_DEVICE;
    case 2:
    case "PERMISSION_MCP":
      return TokenPermission.PERMISSION_MCP;
    case 100:
    case "PERMISSION_TEST":
      return TokenPermission.PERMISSION_TEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TokenPermission.UNRECOGNIZED;
  }
}

export function tokenPermissionToJSON(object: TokenPermission): string {
  switch (object) {
    case TokenPermission.PERMISSION_UNSPECIFIED:
      return "PERMISSION_UNSPECIFIED";
    case TokenPermission.PERMISSION_ONBOARD_DEVICE:
      return "PERMISSION_ONBOARD_DEVICE";
    case TokenPermission.PERMISSION_MCP:
      return "PERMISSION_MCP";
    case TokenPermission.PERMISSION_TEST:
      return "PERMISSION_TEST";
    case TokenPermission.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum HttpMethod {
  HTTP_METHOD_UNSPECIFIED = 0,
  GET = 1,
  POST = 2,
  PUT = 3,
  DELETE = 4,
  UNRECOGNIZED = -1,
}

export function httpMethodFromJSON(object: any): HttpMethod {
  switch (object) {
    case 0:
    case "HTTP_METHOD_UNSPECIFIED":
      return HttpMethod.HTTP_METHOD_UNSPECIFIED;
    case 1:
    case "GET":
      return HttpMethod.GET;
    case 2:
    case "POST":
      return HttpMethod.POST;
    case 3:
    case "PUT":
      return HttpMethod.PUT;
    case 4:
    case "DELETE":
      return HttpMethod.DELETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HttpMethod.UNRECOGNIZED;
  }
}

export function httpMethodToJSON(object: HttpMethod): string {
  switch (object) {
    case HttpMethod.HTTP_METHOD_UNSPECIFIED:
      return "HTTP_METHOD_UNSPECIFIED";
    case HttpMethod.GET:
      return "GET";
    case HttpMethod.POST:
      return "POST";
    case HttpMethod.PUT:
      return "PUT";
    case HttpMethod.DELETE:
      return "DELETE";
    case HttpMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * RoutingPolicy defines a scheme for routing an endpoint to its service instance. Most
 * endpoints will be routed by fabricId, eg /api/v1/fabrics/{fabric_id}/nodes etc
 * but some endpoints must be tied to a specific instance of a service.
 *
 * The annotation is ultimately used by Fred to determine the service instance.
 * If the annotation is not specified Fred will default to its usual set of rules.
 */
export enum RoutingPolicy {
  ROUTING_POLICY_UNSPECIFIED = 0,
  LOAD_BALANCED = 1,
  ASSIGNMENT = 2,
  UNRECOGNIZED = -1,
}

export function routingPolicyFromJSON(object: any): RoutingPolicy {
  switch (object) {
    case 0:
    case "ROUTING_POLICY_UNSPECIFIED":
      return RoutingPolicy.ROUTING_POLICY_UNSPECIFIED;
    case 1:
    case "LOAD_BALANCED":
      return RoutingPolicy.LOAD_BALANCED;
    case 2:
    case "ASSIGNMENT":
      return RoutingPolicy.ASSIGNMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RoutingPolicy.UNRECOGNIZED;
  }
}

export function routingPolicyToJSON(object: RoutingPolicy): string {
  switch (object) {
    case RoutingPolicy.ROUTING_POLICY_UNSPECIFIED:
      return "ROUTING_POLICY_UNSPECIFIED";
    case RoutingPolicy.LOAD_BALANCED:
      return "LOAD_BALANCED";
    case RoutingPolicy.ASSIGNMENT:
      return "ASSIGNMENT";
    case RoutingPolicy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * AuthRole is a basic copy of the models.UserRole enum. However in order to avoid
 * circular dependencies it is replicated here to be used as an annotation. The
 * rest Protobuf package must not depend on the models package.
 */
export enum AuthRole {
  AUTH_ROLE_UNSPECIFIED = 0,
  AUTH_ADMIN = 1,
  AUTH_READ_WRITE = 2,
  AUTH_READ_ONLY = 3,
  UNRECOGNIZED = -1,
}

export function authRoleFromJSON(object: any): AuthRole {
  switch (object) {
    case 0:
    case "AUTH_ROLE_UNSPECIFIED":
      return AuthRole.AUTH_ROLE_UNSPECIFIED;
    case 1:
    case "AUTH_ADMIN":
      return AuthRole.AUTH_ADMIN;
    case 2:
    case "AUTH_READ_WRITE":
      return AuthRole.AUTH_READ_WRITE;
    case 3:
    case "AUTH_READ_ONLY":
      return AuthRole.AUTH_READ_ONLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthRole.UNRECOGNIZED;
  }
}

export function authRoleToJSON(object: AuthRole): string {
  switch (object) {
    case AuthRole.AUTH_ROLE_UNSPECIFIED:
      return "AUTH_ROLE_UNSPECIFIED";
    case AuthRole.AUTH_ADMIN:
      return "AUTH_ADMIN";
    case AuthRole.AUTH_READ_WRITE:
      return "AUTH_READ_WRITE";
    case AuthRole.AUTH_READ_ONLY:
      return "AUTH_READ_ONLY";
    case AuthRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** GenSdk determines whether SDK code should be generated for a given endpoint. */
export enum GenSdk {
  GEN_SDK_UNSPECIFIED = 0,
  /** SUPPRESS - The SDK is generated for the REST API. */
  SUPPRESS = 1,
  UNRECOGNIZED = -1,
}

export function genSdkFromJSON(object: any): GenSdk {
  switch (object) {
    case 0:
    case "GEN_SDK_UNSPECIFIED":
      return GenSdk.GEN_SDK_UNSPECIFIED;
    case 1:
    case "SUPPRESS":
      return GenSdk.SUPPRESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GenSdk.UNRECOGNIZED;
  }
}

export function genSdkToJSON(object: GenSdk): string {
  switch (object) {
    case GenSdk.GEN_SDK_UNSPECIFIED:
      return "GEN_SDK_UNSPECIFIED";
    case GenSdk.SUPPRESS:
      return "SUPPRESS";
    case GenSdk.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** MarshalerOption defines options that can be passed to the default marshaler for a given Content-Type. */
export enum MarshalerOption {
  MARSHALER_UNSPECIFIED = 0,
  /** ALLOW_UNKNOWNS - The default payload is expected to be JSON but unknown fields in the payload are ignored. */
  ALLOW_UNKNOWNS = 1,
  /**
   * JSONRPC_ENVELOPE - Wraps incoming JSON-RPC 2.0 payloads in a protobuf Struct envelope for transport
   * through the handler pipeline. Used by MCP endpoints.
   *
   * @deprecated
   */
  JSONRPC_ENVELOPE = 2,
  UNRECOGNIZED = -1,
}

export function marshalerOptionFromJSON(object: any): MarshalerOption {
  switch (object) {
    case 0:
    case "MARSHALER_UNSPECIFIED":
      return MarshalerOption.MARSHALER_UNSPECIFIED;
    case 1:
    case "ALLOW_UNKNOWNS":
      return MarshalerOption.ALLOW_UNKNOWNS;
    case 2:
    case "JSONRPC_ENVELOPE":
      return MarshalerOption.JSONRPC_ENVELOPE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MarshalerOption.UNRECOGNIZED;
  }
}

export function marshalerOptionToJSON(object: MarshalerOption): string {
  switch (object) {
    case MarshalerOption.MARSHALER_UNSPECIFIED:
      return "MARSHALER_UNSPECIFIED";
    case MarshalerOption.ALLOW_UNKNOWNS:
      return "ALLOW_UNKNOWNS";
    case MarshalerOption.JSONRPC_ENVELOPE:
      return "JSONRPC_ENVELOPE";
    case MarshalerOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * HandlerType specifies the type of request handler that must be provided for an endpoint.
 * Most will be a gRPC look-alike style but a few will need direct access to the ResponseWriter.
 */
export enum HandlerType {
  HANDLER_TYPE_UNSPECIFIED = 0,
  HTTP = 1,
  GRPC = 2,
  UNRECOGNIZED = -1,
}

export function handlerTypeFromJSON(object: any): HandlerType {
  switch (object) {
    case 0:
    case "HANDLER_TYPE_UNSPECIFIED":
      return HandlerType.HANDLER_TYPE_UNSPECIFIED;
    case 1:
    case "HTTP":
      return HandlerType.HTTP;
    case 2:
    case "GRPC":
      return HandlerType.GRPC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HandlerType.UNRECOGNIZED;
  }
}

export function handlerTypeToJSON(object: HandlerType): string {
  switch (object) {
    case HandlerType.HANDLER_TYPE_UNSPECIFIED:
      return "HANDLER_TYPE_UNSPECIFIED";
    case HandlerType.HTTP:
      return "HTTP";
    case HandlerType.GRPC:
      return "GRPC";
    case HandlerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * AuthClient defines an annotation for endpoints listing the acceptable
 * authorization schemes for that endpoint.
 *
 * This annotation is required, and, if not specified, will result in a compilation error.
 *
 * Generally, annotating an endpoint with one or more authorization schemes should be viewed
 * as a mechanism for restricting what clients (WebUI, devices, scripts etc) can use the
 * endpoint. For example, REST endpoints for logging in/out or switching tenants only make
 * sense in the context of the WebUI. Similarly for device specific endpoints.
 *
 * This is not entirely foolproof but generally makes things more complicated.
 */
export enum AuthClient {
  AUTH_CLIENT_UNSPECIFIED = 0,
  /**
   * NOAUTH - For some special endpoints, no authorization is required. This would be logging in for example.
   * This cannot be used as a service level client, only on the endpoint.
   */
  NOAUTH = 1,
  /** REST - The endpoint can be authenticated using a user bearer token, or API KEY (ed25519, RSA). */
  REST = 2,
  /** WEB - The endpoint can be authenticated using a cookie resulting from a logged in user. */
  WEB = 3,
  /** DEVICE - The endpoint can be authenticated using a client certificate. */
  DEVICE = 4,
  /** SERVICE - Service to service client. This is client-certificate. */
  SERVICE = 5,
  /**
   * SUPPORT_WEB - The endpoint can be authenticated using a cookie resulting from a logged in user for the
   * Mgmt or Support UI
   */
  SUPPORT_WEB = 6,
  /** CLIENT_TOKEN - This is a bearer token created by an external Duo application. */
  CLIENT_TOKEN = 7,
  UNRECOGNIZED = -1,
}

export function authClientFromJSON(object: any): AuthClient {
  switch (object) {
    case 0:
    case "AUTH_CLIENT_UNSPECIFIED":
      return AuthClient.AUTH_CLIENT_UNSPECIFIED;
    case 1:
    case "NOAUTH":
      return AuthClient.NOAUTH;
    case 2:
    case "REST":
      return AuthClient.REST;
    case 3:
    case "WEB":
      return AuthClient.WEB;
    case 4:
    case "DEVICE":
      return AuthClient.DEVICE;
    case 5:
    case "SERVICE":
      return AuthClient.SERVICE;
    case 6:
    case "SUPPORT_WEB":
      return AuthClient.SUPPORT_WEB;
    case 7:
    case "CLIENT_TOKEN":
      return AuthClient.CLIENT_TOKEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthClient.UNRECOGNIZED;
  }
}

export function authClientToJSON(object: AuthClient): string {
  switch (object) {
    case AuthClient.AUTH_CLIENT_UNSPECIFIED:
      return "AUTH_CLIENT_UNSPECIFIED";
    case AuthClient.NOAUTH:
      return "NOAUTH";
    case AuthClient.REST:
      return "REST";
    case AuthClient.WEB:
      return "WEB";
    case AuthClient.DEVICE:
      return "DEVICE";
    case AuthClient.SERVICE:
      return "SERVICE";
    case AuthClient.SUPPORT_WEB:
      return "SUPPORT_WEB";
    case AuthClient.CLIENT_TOKEN:
      return "CLIENT_TOKEN";
    case AuthClient.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Tag values can be associated with an API and provide a way to
 * categorize calls for documentation purposes.
 *
 * NOTE:
 * Tags are used in different places and can impact how the generated code looks.
 * Please only use a single word for tags, eg FOO rather than FOO_BAR.
 */
export enum Tag {
  TAG_UNSPECIFIED = 0,
  /** MISC - Uncategorized APIs. */
  MISC = 1,
  /** FABRICS - APIs for managing fabrics, candidate configurations and fabric connections. */
  FABRICS = 2,
  /** NODES - APIs for managing nodes, ports, port channels and other interfaces. */
  NODES = 3,
  /** PORTS - APIs for chassis port configuration and state. */
  PORTS = 4,
  /** AUTH - APIs for managing authorization, account, users, API keys and tokens. */
  AUTH = 5,
  /** NETWORKS - APIs for network configuration. */
  NETWORKS = 6,
  /** HISTORY - APIs for historical data such as assertions and port traffic. */
  HISTORY = 7,
  /** PROVISION - APIs for large configuration changes. */
  PROVISION = 8,
  /** ADMIN - APIs for internal administrative behavior. */
  ADMIN = 9,
  /** INTERNAL - APIs for communication internal to the Tortuga services */
  INTERNAL = 10,
  /** TENANTS - APIs for managing tenants. */
  TENANTS = 11,
  /** DEVICES - APIs for managing devices. */
  DEVICES = 12,
  /** STATE - APIs for the runtime state of the system. */
  STATE = 13,
  /** CREDENTIALS - APIs for credentials. */
  CREDENTIALS = 14,
  /** VNIS - APIs for managing VNIs */
  VNIS = 15,
  /** VRFS - APIs for managing VRFs. */
  VRFS = 16,
  /** CHATBOTS - APIs for chatbots */
  CHATBOTS = 17,
  /** CLICMDS - APIs for CLI commands */
  CLICMDS = 18,
  /** SUPPORT - APIs for support. */
  SUPPORT = 19,
  /** REFERENCE_POINTS - APIs for fabric reference points. */
  REFERENCE_POINTS = 20,
  /** DEMO - APIs for internal demo purposes. */
  DEMO = 21,
  /** BGP_POLICIES - APIs for BGP Policies */
  BGP_POLICIES = 22,
  /** NOTIFICATIONS - APIs for managing notification endpoints. */
  NOTIFICATIONS = 23,
  /** ASSERTIONS - APIs for managing assertions. */
  ASSERTIONS = 24,
  /** PORT_CHANNELS - APIs for managing port channels on a fabric. */
  PORT_CHANNELS = 25,
  /** IMAGE_UPDATE - APIs for device image update. */
  IMAGE_UPDATE = 26,
  /** IPM_CONFIG - APIs for IPM configs. */
  IPM_CONFIG = 27,
  /** GLOBAL - APIs that span across organizations. */
  GLOBAL = 28,
  /** CERTIFICATES - APIs for managing certificates. */
  CERTIFICATES = 29,
  /** DSCP - APIs for DSCP configs. */
  DSCP = 30,
  /** PERISCOPE - APIs for Periscope. */
  PERISCOPE = 31,
  /** ROUTING - APIs for routing requests. */
  ROUTING = 32,
  /** TEMPLATES - APIs for Fabric Blueprint Templates */
  TEMPLATES = 33,
  /** CABLING_PLANS - APIs for Cabling Plans */
  CABLING_PLANS = 34,
  /** PACKET_MIRRORING - APIs for packet mirroring. */
  PACKET_MIRRORING = 35,
  /** IP_SLA_CONFIG - APIs for IP/SLA. */
  IP_SLA_CONFIG = 36,
  /** DCI_CONFIG - APIs for DCI. */
  DCI_CONFIG = 37,
  /** DESIGN - APIs for managing fabric design objects. */
  DESIGN = 38,
  /** MONITOR - APIs for monitoring fabrics. */
  MONITOR = 39,
  /** BGP - APIs for BGP peers and policies. */
  BGP = 40,
  /** ARS_CONFIG - APIs for ARS configs. */
  ARS_CONFIG = 41,
  /** DASHBOARDS - APIs for dashboard management. */
  DASHBOARDS = 42,
  /** TSIMLITE - APIs for tsimlite device simulation tool. */
  TSIMLITE = 43,
  /** MULTISITE - APIs for MultiSite configuration. */
  MULTISITE = 44,
  /** TENANT_RESERVATIONS - APIs for Tenant reservations. */
  TENANT_RESERVATIONS = 45,
  UNRECOGNIZED = -1,
}

export function tagFromJSON(object: any): Tag {
  switch (object) {
    case 0:
    case "TAG_UNSPECIFIED":
      return Tag.TAG_UNSPECIFIED;
    case 1:
    case "MISC":
      return Tag.MISC;
    case 2:
    case "FABRICS":
      return Tag.FABRICS;
    case 3:
    case "NODES":
      return Tag.NODES;
    case 4:
    case "PORTS":
      return Tag.PORTS;
    case 5:
    case "AUTH":
      return Tag.AUTH;
    case 6:
    case "NETWORKS":
      return Tag.NETWORKS;
    case 7:
    case "HISTORY":
      return Tag.HISTORY;
    case 8:
    case "PROVISION":
      return Tag.PROVISION;
    case 9:
    case "ADMIN":
      return Tag.ADMIN;
    case 10:
    case "INTERNAL":
      return Tag.INTERNAL;
    case 11:
    case "TENANTS":
      return Tag.TENANTS;
    case 12:
    case "DEVICES":
      return Tag.DEVICES;
    case 13:
    case "STATE":
      return Tag.STATE;
    case 14:
    case "CREDENTIALS":
      return Tag.CREDENTIALS;
    case 15:
    case "VNIS":
      return Tag.VNIS;
    case 16:
    case "VRFS":
      return Tag.VRFS;
    case 17:
    case "CHATBOTS":
      return Tag.CHATBOTS;
    case 18:
    case "CLICMDS":
      return Tag.CLICMDS;
    case 19:
    case "SUPPORT":
      return Tag.SUPPORT;
    case 20:
    case "REFERENCE_POINTS":
      return Tag.REFERENCE_POINTS;
    case 21:
    case "DEMO":
      return Tag.DEMO;
    case 22:
    case "BGP_POLICIES":
      return Tag.BGP_POLICIES;
    case 23:
    case "NOTIFICATIONS":
      return Tag.NOTIFICATIONS;
    case 24:
    case "ASSERTIONS":
      return Tag.ASSERTIONS;
    case 25:
    case "PORT_CHANNELS":
      return Tag.PORT_CHANNELS;
    case 26:
    case "IMAGE_UPDATE":
      return Tag.IMAGE_UPDATE;
    case 27:
    case "IPM_CONFIG":
      return Tag.IPM_CONFIG;
    case 28:
    case "GLOBAL":
      return Tag.GLOBAL;
    case 29:
    case "CERTIFICATES":
      return Tag.CERTIFICATES;
    case 30:
    case "DSCP":
      return Tag.DSCP;
    case 31:
    case "PERISCOPE":
      return Tag.PERISCOPE;
    case 32:
    case "ROUTING":
      return Tag.ROUTING;
    case 33:
    case "TEMPLATES":
      return Tag.TEMPLATES;
    case 34:
    case "CABLING_PLANS":
      return Tag.CABLING_PLANS;
    case 35:
    case "PACKET_MIRRORING":
      return Tag.PACKET_MIRRORING;
    case 36:
    case "IP_SLA_CONFIG":
      return Tag.IP_SLA_CONFIG;
    case 37:
    case "DCI_CONFIG":
      return Tag.DCI_CONFIG;
    case 38:
    case "DESIGN":
      return Tag.DESIGN;
    case 39:
    case "MONITOR":
      return Tag.MONITOR;
    case 40:
    case "BGP":
      return Tag.BGP;
    case 41:
    case "ARS_CONFIG":
      return Tag.ARS_CONFIG;
    case 42:
    case "DASHBOARDS":
      return Tag.DASHBOARDS;
    case 43:
    case "TSIMLITE":
      return Tag.TSIMLITE;
    case 44:
    case "MULTISITE":
      return Tag.MULTISITE;
    case 45:
    case "TENANT_RESERVATIONS":
      return Tag.TENANT_RESERVATIONS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Tag.UNRECOGNIZED;
  }
}

export function tagToJSON(object: Tag): string {
  switch (object) {
    case Tag.TAG_UNSPECIFIED:
      return "TAG_UNSPECIFIED";
    case Tag.MISC:
      return "MISC";
    case Tag.FABRICS:
      return "FABRICS";
    case Tag.NODES:
      return "NODES";
    case Tag.PORTS:
      return "PORTS";
    case Tag.AUTH:
      return "AUTH";
    case Tag.NETWORKS:
      return "NETWORKS";
    case Tag.HISTORY:
      return "HISTORY";
    case Tag.PROVISION:
      return "PROVISION";
    case Tag.ADMIN:
      return "ADMIN";
    case Tag.INTERNAL:
      return "INTERNAL";
    case Tag.TENANTS:
      return "TENANTS";
    case Tag.DEVICES:
      return "DEVICES";
    case Tag.STATE:
      return "STATE";
    case Tag.CREDENTIALS:
      return "CREDENTIALS";
    case Tag.VNIS:
      return "VNIS";
    case Tag.VRFS:
      return "VRFS";
    case Tag.CHATBOTS:
      return "CHATBOTS";
    case Tag.CLICMDS:
      return "CLICMDS";
    case Tag.SUPPORT:
      return "SUPPORT";
    case Tag.REFERENCE_POINTS:
      return "REFERENCE_POINTS";
    case Tag.DEMO:
      return "DEMO";
    case Tag.BGP_POLICIES:
      return "BGP_POLICIES";
    case Tag.NOTIFICATIONS:
      return "NOTIFICATIONS";
    case Tag.ASSERTIONS:
      return "ASSERTIONS";
    case Tag.PORT_CHANNELS:
      return "PORT_CHANNELS";
    case Tag.IMAGE_UPDATE:
      return "IMAGE_UPDATE";
    case Tag.IPM_CONFIG:
      return "IPM_CONFIG";
    case Tag.GLOBAL:
      return "GLOBAL";
    case Tag.CERTIFICATES:
      return "CERTIFICATES";
    case Tag.DSCP:
      return "DSCP";
    case Tag.PERISCOPE:
      return "PERISCOPE";
    case Tag.ROUTING:
      return "ROUTING";
    case Tag.TEMPLATES:
      return "TEMPLATES";
    case Tag.CABLING_PLANS:
      return "CABLING_PLANS";
    case Tag.PACKET_MIRRORING:
      return "PACKET_MIRRORING";
    case Tag.IP_SLA_CONFIG:
      return "IP_SLA_CONFIG";
    case Tag.DCI_CONFIG:
      return "DCI_CONFIG";
    case Tag.DESIGN:
      return "DESIGN";
    case Tag.MONITOR:
      return "MONITOR";
    case Tag.BGP:
      return "BGP";
    case Tag.ARS_CONFIG:
      return "ARS_CONFIG";
    case Tag.DASHBOARDS:
      return "DASHBOARDS";
    case Tag.TSIMLITE:
      return "TSIMLITE";
    case Tag.MULTISITE:
      return "MULTISITE";
    case Tag.TENANT_RESERVATIONS:
      return "TENANT_RESERVATIONS";
    case Tag.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** NotAvailable is a placeholder message for storing a generic example for request/response messages. */
export interface NotAvailable {
  msg: string;
}

/** ServerOptions annotate rpc services for REST API documentation and routing. */
export interface ServerOptions {
  svc: Service;
  /** The hostname to use, defaults to localhost. */
  host: string;
  /** The port to use, defaults to Fred, 9401. */
  port: string;
  /** The default grouping for APIs. This can be overwritten by individual calls. */
  tag: Tag;
  /**
   * status defines one or more HTTP status codes that can be returned by all APIs
   * defined within the service definition. Individual APIs may define additional
   * status codes if the API returns it.
   *
   *  403 (PermissionDenied)
   *  429 (TooManyRequest)
   *  500 (InternalServerError)
   */
  status: number[];
  /**
   * auth lists one or more accepted authorization schemes for an endpoint. This is a required
   * annotation and serves as the default for all endpoints defined in the service. Individual
   * endpoints can override the default by specifying the auth annotation separately.
   */
  auth: AuthClient[];
  /** Policy defines the default routing policy for gRPC methods in the service. */
  policy: RoutingPolicy;
  /**
   * Internal states that the APIs defined in the service file are internal APIs. Such APIs
   * are not published to Krang and are only accessible through direct access to the service.
   */
  internal: boolean;
  /**
   * max_req_size sets the default maximum request body size for all endpoints in the
   * service. Individual endpoints can override this with their own max_req_size annotation.
   * Uses nginx notation: "1k", "16m", "1g" (case-insensitive). If not set, the global
   * default (16m) is used.
   */
  maxReqSize: string;
}

/** ApiOptions annotate rpc methods for REST API documentation. */
export interface ApiOptions {
  /** The REST API endpoint. */
  endpoint: string;
  /** The HTTP method for the API. The default is Method_GET. */
  method: HttpMethod;
  /** The API is hidden. This means it is not documented but may still be called. */
  hidden: boolean;
  /**
   * A JSON document containing example data to be used for PUT operations.
   * These files MUST NOT contain any sensitive or internal information as this
   * will be visible to the customer. Only the file name is required. The
   * protoc-gen-restdocs plugin is configured with the path containing the file.
   */
  request: string;
  response: string;
  /** Simple mechanism for grouping related calls. */
  tag: Tag;
  /**
   * Body annotation is used for PUT requests where the data uploaded by
   * the client is not the request message itself but rather a field in the
   * request message.
   *
   * The body annotation must be a field name in the request.
   *
   * For example:
   *
   * message FabricDetails {
   *   string name = 1;
   *   string description = 2;
   * }
   *
   * message UpdateFabricRequest {
   *   string fabric_id = 1;
   *   FabricDetails fabric = 2;
   * }
   *
   * rpc UpdateFabric(UpdateFabricRequest) returns (FabricDetails) {
   *   options (rest.request) = {
   *     endpoint: "/api/v1/fabrics/{fabric_id}"
   *     method: PUT
   *     body: "{fabric}"
   *   };
   * }
   *
   * PUT request body.
   *
   * {
   *   "name": "New name",
   *   "description": "New description"
   * }
   *
   * In this example, the JSON document in the request is FabricDetails rather than UpdateFabricRequest.
   *
   * The request handler will receive an instance of UpdateFabricRequest where both the fabric_id
   * and the fabric message are fully populated.
   */
  body: string;
  /**
   * noschema governs whether a JSON schema is generated for a request. For some PUT/POST requests
   * a body is not required and the path parameters provide enough information to complete the request.
   * For example, to bind a switch to a chassis use:
   *
   *   PUT /api/v1/chassis/{chassis_id}/switches/{switch_id}
   *
   * No body is needed here since the path parameters provide all the necessary information.
   */
  noschema: boolean;
  /**
   * status defines one or more HTTP status codes that can be returned by an API call.
   * By default, all calls return a 200/204 and there are additional default returns calls
   *
   *  403 (PermissionDenied)
   *  429 (TooManyRequest)
   *  500 (InternalServerError)
   *
   * These are defined as a service level annotation.
   *
   * Some APIs may also return:
   *  400 (BadArgument)
   *  404 (NotFound)
   *
   * The annotation defines a list of status codes that can be returned by the API
   * in addition to the common ones defined by the service level annotation.
   * It is an array of integer values where the value is a valid http.Status value.
   */
  status: number[];
  /**
   * auth lists one or more accepted authorization schemes for an endpoint. If not specified,
   * then the service level setting applies. If set, this will override the service level.
   */
  auth: AuthClient[];
  /**
   * role defines the minimum user role needed to execute the API. This is optional and if
   * omitted it is the responsibility of the handler to authorize the request.
   */
  role: AuthRole;
  /**
   * Handler specifies the type of the handler for the endpoint. There will be a small number
   * of API calls that will need direct access to the ResponseWriter and don't fit the gRPC
   * look-alike model.
   */
  handler: HandlerType;
  /**
   * MarshalerOption allows endpoints declare options to be used for the default marshaler.
   * So it means that endpoints can tweak the behavior of the marshaler.
   */
  marshaler: MarshalerOption[];
  /** Policy overrides the default routing policy for requests in Fred. */
  policy: RoutingPolicy;
  /** Allow unknown query parameters */
  allowUnknownQueryParams: boolean;
  /** gensdk can be used to suppress generating SDK code. */
  gensdk: GenSdk;
  /** Implements a syncfollow websocket based connection. */
  websocket: boolean;
  /** Indicates that the endpoint is deprecated and should not be used. */
  deprecated: boolean;
  /**
   * OperationId can be used to set the OpenAPI operationId value for an API.
   * The default value is the rpc name but this can be used to overwrite that
   * value if the function name needs to change but preserve backward compatility.
   */
  operationId: string;
  /**
   * Permissions define the areas of functionality where a token, with at least the same
   * set of permissions, can be used.
   */
  permissions: TokenPermission[];
  /**
   * binding defines a customized client side binding for API endpoints.
   *
   * binding without a ReST endpoint will be ignored in typescript, but will still be applied
   * in Go and Python
   */
  binding: string;
  /**
   * max_req_size overrides the service-level max_req_size for this specific endpoint.
   * Uses nginx notation: "1k", "16m", "1g" (case-insensitive). If not set, the
   * service-level default applies. If neither is set, the global default (16m) is used.
   */
  maxReqSize: string;
}

/** Placeholder. */
export interface RequestOptions {
}

/** Placeholder. */
export interface ResponseOptions {
}

/** MessageOptions define annotations for messages. */
export interface MessageOptions {
  /** hidden indicates that a message should not be documented. */
  hidden: boolean;
  /** readonly indicates that a message is read-only data in all scenarios. */
  readonly: boolean;
}

/**
 * FieldOptions define annotations for fields within a request message.
 * For requests they can flag that a particular field in POST/PUT data is required.
 */
export interface FieldOptions {
  /**
   * require marks a field as mandatory. This can be used for POST/PUT data
   * where the documentation will tag the field as a required field.
   */
  require: boolean;
  /**
   * hidden indicates that a field in a request message, which might otherwise show up as
   * a query parameter should not be documented. It is still usable however.
   */
  hidden: boolean;
  /**
   * readonly indicates that a field in a request/response message is readonly. Typical
   * examples are a resource id or the metadata field in a response object. Fields marked
   * as readonly should not be documented in request messages.
   */
  readonly: boolean;
  /** internal is a shorthand for setting both the hidden and readonly annotations. */
  internal: boolean;
  /**
   * export_omit marks a field that must be stripped before being written to
   * an external export pipeline. Exporters walk the message via proto
   * reflection and clear every export_omit field recursively.
   */
  exportOmit: boolean;
}

export interface EnumOptions {
  /** hidden indicates that a an entire enum should be excluded from the generated spec. */
  hidden: boolean;
}

/** EnumValueOptions define options that can be set for individual enum values. */
export interface EnumValueOptions {
  /** hidden indicates that the enum value should not be documented. */
  hidden: boolean;
  /**
   * default marks an enum value as the default value for the enum.
   *
   * Note from the protobuf.dev pages:
   *
   * "Almost never change the default value of a proto field. This causes version skew between
   *  clients and servers. A client reading an unset value will see a different result than a
   *  server reading the same unset value when their builds straddle the proto change.
   *  Proto3 removed the ability to set default values."
   */
  default: boolean;
  /** reserve marks the value as a reserved value which should not be used. */
  reserve: boolean;
}

function createBaseNotAvailable(): NotAvailable {
  return { msg: "" };
}

export const NotAvailable: MessageFns<NotAvailable> = {
  encode(message: NotAvailable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.msg !== "") {
      writer.uint32(10).string(message.msg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotAvailable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotAvailable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.msg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotAvailable {
    return { msg: isSet(object.msg) ? globalThis.String(object.msg) : "" };
  },

  toJSON(message: NotAvailable): unknown {
    const obj: any = {};
    if (message.msg !== "") {
      obj.msg = message.msg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NotAvailable>, I>>(base?: I): NotAvailable {
    return NotAvailable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NotAvailable>, I>>(object: I): NotAvailable {
    const message = createBaseNotAvailable();
    message.msg = object.msg ?? "";
    return message;
  },
};

function createBaseServerOptions(): ServerOptions {
  return { svc: 0, host: "", port: "0", tag: 0, status: [], auth: [], policy: 0, internal: false, maxReqSize: "" };
}

export const ServerOptions: MessageFns<ServerOptions> = {
  encode(message: ServerOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.svc !== 0) {
      writer.uint32(8).int32(message.svc);
    }
    if (message.host !== "") {
      writer.uint32(18).string(message.host);
    }
    if (message.port !== "0") {
      writer.uint32(24).int64(message.port);
    }
    if (message.tag !== 0) {
      writer.uint32(32).int32(message.tag);
    }
    writer.uint32(42).fork();
    for (const v of message.status) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(82).fork();
    for (const v of message.auth) {
      writer.int32(v);
    }
    writer.join();
    if (message.policy !== 0) {
      writer.uint32(88).int32(message.policy);
    }
    if (message.internal !== false) {
      writer.uint32(96).bool(message.internal);
    }
    if (message.maxReqSize !== "") {
      writer.uint32(106).string(message.maxReqSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.svc = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.host = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.port = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tag = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.status.push(reader.int32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.status.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag === 80) {
            message.auth.push(reader.int32() as any);

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.auth.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.policy = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.internal = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.maxReqSize = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerOptions {
    return {
      svc: isSet(object.svc) ? serviceFromJSON(object.svc) : 0,
      host: isSet(object.host) ? globalThis.String(object.host) : "",
      port: isSet(object.port) ? globalThis.String(object.port) : "0",
      tag: isSet(object.tag) ? tagFromJSON(object.tag) : 0,
      status: globalThis.Array.isArray(object?.status) ? object.status.map((e: any) => globalThis.Number(e)) : [],
      auth: globalThis.Array.isArray(object?.auth) ? object.auth.map((e: any) => authClientFromJSON(e)) : [],
      policy: isSet(object.policy) ? routingPolicyFromJSON(object.policy) : 0,
      internal: isSet(object.internal) ? globalThis.Boolean(object.internal) : false,
      maxReqSize: isSet(object.maxReqSize) ? globalThis.String(object.maxReqSize) : "",
    };
  },

  toJSON(message: ServerOptions): unknown {
    const obj: any = {};
    if (message.svc !== 0) {
      obj.svc = serviceToJSON(message.svc);
    }
    if (message.host !== "") {
      obj.host = message.host;
    }
    if (message.port !== "0") {
      obj.port = message.port;
    }
    if (message.tag !== 0) {
      obj.tag = tagToJSON(message.tag);
    }
    if (message.status?.length) {
      obj.status = message.status.map((e) => Math.round(e));
    }
    if (message.auth?.length) {
      obj.auth = message.auth.map((e) => authClientToJSON(e));
    }
    if (message.policy !== 0) {
      obj.policy = routingPolicyToJSON(message.policy);
    }
    if (message.internal !== false) {
      obj.internal = message.internal;
    }
    if (message.maxReqSize !== "") {
      obj.maxReqSize = message.maxReqSize;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerOptions>, I>>(base?: I): ServerOptions {
    return ServerOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerOptions>, I>>(object: I): ServerOptions {
    const message = createBaseServerOptions();
    message.svc = object.svc ?? 0;
    message.host = object.host ?? "";
    message.port = object.port ?? "0";
    message.tag = object.tag ?? 0;
    message.status = object.status?.map((e) => e) || [];
    message.auth = object.auth?.map((e) => e) || [];
    message.policy = object.policy ?? 0;
    message.internal = object.internal ?? false;
    message.maxReqSize = object.maxReqSize ?? "";
    return message;
  },
};

function createBaseApiOptions(): ApiOptions {
  return {
    endpoint: "",
    method: 0,
    hidden: false,
    request: "",
    response: "",
    tag: 0,
    body: "",
    noschema: false,
    status: [],
    auth: [],
    role: 0,
    handler: 0,
    marshaler: [],
    policy: 0,
    allowUnknownQueryParams: false,
    gensdk: 0,
    websocket: false,
    deprecated: false,
    operationId: "",
    permissions: [],
    binding: "",
    maxReqSize: "",
  };
}

export const ApiOptions: MessageFns<ApiOptions> = {
  encode(message: ApiOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.endpoint !== "") {
      writer.uint32(10).string(message.endpoint);
    }
    if (message.method !== 0) {
      writer.uint32(16).int32(message.method);
    }
    if (message.hidden !== false) {
      writer.uint32(24).bool(message.hidden);
    }
    if (message.request !== "") {
      writer.uint32(34).string(message.request);
    }
    if (message.response !== "") {
      writer.uint32(42).string(message.response);
    }
    if (message.tag !== 0) {
      writer.uint32(48).int32(message.tag);
    }
    if (message.body !== "") {
      writer.uint32(58).string(message.body);
    }
    if (message.noschema !== false) {
      writer.uint32(64).bool(message.noschema);
    }
    writer.uint32(74).fork();
    for (const v of message.status) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(82).fork();
    for (const v of message.auth) {
      writer.int32(v);
    }
    writer.join();
    if (message.role !== 0) {
      writer.uint32(88).int32(message.role);
    }
    if (message.handler !== 0) {
      writer.uint32(96).int32(message.handler);
    }
    writer.uint32(106).fork();
    for (const v of message.marshaler) {
      writer.int32(v);
    }
    writer.join();
    if (message.policy !== 0) {
      writer.uint32(112).int32(message.policy);
    }
    if (message.allowUnknownQueryParams !== false) {
      writer.uint32(120).bool(message.allowUnknownQueryParams);
    }
    if (message.gensdk !== 0) {
      writer.uint32(128).int32(message.gensdk);
    }
    if (message.websocket !== false) {
      writer.uint32(136).bool(message.websocket);
    }
    if (message.deprecated !== false) {
      writer.uint32(144).bool(message.deprecated);
    }
    if (message.operationId !== "") {
      writer.uint32(154).string(message.operationId);
    }
    writer.uint32(162).fork();
    for (const v of message.permissions) {
      writer.int32(v);
    }
    writer.join();
    if (message.binding !== "") {
      writer.uint32(170).string(message.binding);
    }
    if (message.maxReqSize !== "") {
      writer.uint32(178).string(message.maxReqSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.endpoint = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.method = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.request = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.response = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.tag = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.noschema = reader.bool();
          continue;
        }
        case 9: {
          if (tag === 72) {
            message.status.push(reader.int32());

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.status.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag === 80) {
            message.auth.push(reader.int32() as any);

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.auth.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.handler = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag === 104) {
            message.marshaler.push(reader.int32() as any);

            continue;
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.marshaler.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.policy = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.allowUnknownQueryParams = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.gensdk = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.websocket = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.deprecated = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.operationId = reader.string();
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.permissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.permissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.binding = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.maxReqSize = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiOptions {
    return {
      endpoint: isSet(object.endpoint) ? globalThis.String(object.endpoint) : "",
      method: isSet(object.method) ? httpMethodFromJSON(object.method) : 0,
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
      request: isSet(object.request) ? globalThis.String(object.request) : "",
      response: isSet(object.response) ? globalThis.String(object.response) : "",
      tag: isSet(object.tag) ? tagFromJSON(object.tag) : 0,
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      noschema: isSet(object.noschema) ? globalThis.Boolean(object.noschema) : false,
      status: globalThis.Array.isArray(object?.status) ? object.status.map((e: any) => globalThis.Number(e)) : [],
      auth: globalThis.Array.isArray(object?.auth) ? object.auth.map((e: any) => authClientFromJSON(e)) : [],
      role: isSet(object.role) ? authRoleFromJSON(object.role) : 0,
      handler: isSet(object.handler) ? handlerTypeFromJSON(object.handler) : 0,
      marshaler: globalThis.Array.isArray(object?.marshaler)
        ? object.marshaler.map((e: any) => marshalerOptionFromJSON(e))
        : [],
      policy: isSet(object.policy) ? routingPolicyFromJSON(object.policy) : 0,
      allowUnknownQueryParams: isSet(object.allowUnknownQueryParams)
        ? globalThis.Boolean(object.allowUnknownQueryParams)
        : false,
      gensdk: isSet(object.gensdk) ? genSdkFromJSON(object.gensdk) : 0,
      websocket: isSet(object.websocket) ? globalThis.Boolean(object.websocket) : false,
      deprecated: isSet(object.deprecated) ? globalThis.Boolean(object.deprecated) : false,
      operationId: isSet(object.operationId) ? globalThis.String(object.operationId) : "",
      permissions: globalThis.Array.isArray(object?.permissions)
        ? object.permissions.map((e: any) => tokenPermissionFromJSON(e))
        : [],
      binding: isSet(object.binding) ? globalThis.String(object.binding) : "",
      maxReqSize: isSet(object.maxReqSize) ? globalThis.String(object.maxReqSize) : "",
    };
  },

  toJSON(message: ApiOptions): unknown {
    const obj: any = {};
    if (message.endpoint !== "") {
      obj.endpoint = message.endpoint;
    }
    if (message.method !== 0) {
      obj.method = httpMethodToJSON(message.method);
    }
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    if (message.request !== "") {
      obj.request = message.request;
    }
    if (message.response !== "") {
      obj.response = message.response;
    }
    if (message.tag !== 0) {
      obj.tag = tagToJSON(message.tag);
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.noschema !== false) {
      obj.noschema = message.noschema;
    }
    if (message.status?.length) {
      obj.status = message.status.map((e) => Math.round(e));
    }
    if (message.auth?.length) {
      obj.auth = message.auth.map((e) => authClientToJSON(e));
    }
    if (message.role !== 0) {
      obj.role = authRoleToJSON(message.role);
    }
    if (message.handler !== 0) {
      obj.handler = handlerTypeToJSON(message.handler);
    }
    if (message.marshaler?.length) {
      obj.marshaler = message.marshaler.map((e) => marshalerOptionToJSON(e));
    }
    if (message.policy !== 0) {
      obj.policy = routingPolicyToJSON(message.policy);
    }
    if (message.allowUnknownQueryParams !== false) {
      obj.allowUnknownQueryParams = message.allowUnknownQueryParams;
    }
    if (message.gensdk !== 0) {
      obj.gensdk = genSdkToJSON(message.gensdk);
    }
    if (message.websocket !== false) {
      obj.websocket = message.websocket;
    }
    if (message.deprecated !== false) {
      obj.deprecated = message.deprecated;
    }
    if (message.operationId !== "") {
      obj.operationId = message.operationId;
    }
    if (message.permissions?.length) {
      obj.permissions = message.permissions.map((e) => tokenPermissionToJSON(e));
    }
    if (message.binding !== "") {
      obj.binding = message.binding;
    }
    if (message.maxReqSize !== "") {
      obj.maxReqSize = message.maxReqSize;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiOptions>, I>>(base?: I): ApiOptions {
    return ApiOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiOptions>, I>>(object: I): ApiOptions {
    const message = createBaseApiOptions();
    message.endpoint = object.endpoint ?? "";
    message.method = object.method ?? 0;
    message.hidden = object.hidden ?? false;
    message.request = object.request ?? "";
    message.response = object.response ?? "";
    message.tag = object.tag ?? 0;
    message.body = object.body ?? "";
    message.noschema = object.noschema ?? false;
    message.status = object.status?.map((e) => e) || [];
    message.auth = object.auth?.map((e) => e) || [];
    message.role = object.role ?? 0;
    message.handler = object.handler ?? 0;
    message.marshaler = object.marshaler?.map((e) => e) || [];
    message.policy = object.policy ?? 0;
    message.allowUnknownQueryParams = object.allowUnknownQueryParams ?? false;
    message.gensdk = object.gensdk ?? 0;
    message.websocket = object.websocket ?? false;
    message.deprecated = object.deprecated ?? false;
    message.operationId = object.operationId ?? "";
    message.permissions = object.permissions?.map((e) => e) || [];
    message.binding = object.binding ?? "";
    message.maxReqSize = object.maxReqSize ?? "";
    return message;
  },
};

function createBaseRequestOptions(): RequestOptions {
  return {};
}

export const RequestOptions: MessageFns<RequestOptions> = {
  encode(_: RequestOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RequestOptions {
    return {};
  },

  toJSON(_: RequestOptions): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestOptions>, I>>(base?: I): RequestOptions {
    return RequestOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestOptions>, I>>(_: I): RequestOptions {
    const message = createBaseRequestOptions();
    return message;
  },
};

function createBaseResponseOptions(): ResponseOptions {
  return {};
}

export const ResponseOptions: MessageFns<ResponseOptions> = {
  encode(_: ResponseOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResponseOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ResponseOptions {
    return {};
  },

  toJSON(_: ResponseOptions): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseOptions>, I>>(base?: I): ResponseOptions {
    return ResponseOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseOptions>, I>>(_: I): ResponseOptions {
    const message = createBaseResponseOptions();
    return message;
  },
};

function createBaseMessageOptions(): MessageOptions {
  return { hidden: false, readonly: false };
}

export const MessageOptions: MessageFns<MessageOptions> = {
  encode(message: MessageOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hidden !== false) {
      writer.uint32(8).bool(message.hidden);
    }
    if (message.readonly !== false) {
      writer.uint32(16).bool(message.readonly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.readonly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageOptions {
    return {
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
      readonly: isSet(object.readonly) ? globalThis.Boolean(object.readonly) : false,
    };
  },

  toJSON(message: MessageOptions): unknown {
    const obj: any = {};
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    if (message.readonly !== false) {
      obj.readonly = message.readonly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MessageOptions>, I>>(base?: I): MessageOptions {
    return MessageOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessageOptions>, I>>(object: I): MessageOptions {
    const message = createBaseMessageOptions();
    message.hidden = object.hidden ?? false;
    message.readonly = object.readonly ?? false;
    return message;
  },
};

function createBaseFieldOptions(): FieldOptions {
  return { require: false, hidden: false, readonly: false, internal: false, exportOmit: false };
}

export const FieldOptions: MessageFns<FieldOptions> = {
  encode(message: FieldOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.require !== false) {
      writer.uint32(8).bool(message.require);
    }
    if (message.hidden !== false) {
      writer.uint32(16).bool(message.hidden);
    }
    if (message.readonly !== false) {
      writer.uint32(24).bool(message.readonly);
    }
    if (message.internal !== false) {
      writer.uint32(32).bool(message.internal);
    }
    if (message.exportOmit !== false) {
      writer.uint32(40).bool(message.exportOmit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FieldOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFieldOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.require = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.readonly = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.internal = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.exportOmit = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FieldOptions {
    return {
      require: isSet(object.require) ? globalThis.Boolean(object.require) : false,
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
      readonly: isSet(object.readonly) ? globalThis.Boolean(object.readonly) : false,
      internal: isSet(object.internal) ? globalThis.Boolean(object.internal) : false,
      exportOmit: isSet(object.exportOmit) ? globalThis.Boolean(object.exportOmit) : false,
    };
  },

  toJSON(message: FieldOptions): unknown {
    const obj: any = {};
    if (message.require !== false) {
      obj.require = message.require;
    }
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    if (message.readonly !== false) {
      obj.readonly = message.readonly;
    }
    if (message.internal !== false) {
      obj.internal = message.internal;
    }
    if (message.exportOmit !== false) {
      obj.exportOmit = message.exportOmit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FieldOptions>, I>>(base?: I): FieldOptions {
    return FieldOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FieldOptions>, I>>(object: I): FieldOptions {
    const message = createBaseFieldOptions();
    message.require = object.require ?? false;
    message.hidden = object.hidden ?? false;
    message.readonly = object.readonly ?? false;
    message.internal = object.internal ?? false;
    message.exportOmit = object.exportOmit ?? false;
    return message;
  },
};

function createBaseEnumOptions(): EnumOptions {
  return { hidden: false };
}

export const EnumOptions: MessageFns<EnumOptions> = {
  encode(message: EnumOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hidden !== false) {
      writer.uint32(8).bool(message.hidden);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnumOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnumOptions {
    return { hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false };
  },

  toJSON(message: EnumOptions): unknown {
    const obj: any = {};
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnumOptions>, I>>(base?: I): EnumOptions {
    return EnumOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnumOptions>, I>>(object: I): EnumOptions {
    const message = createBaseEnumOptions();
    message.hidden = object.hidden ?? false;
    return message;
  },
};

function createBaseEnumValueOptions(): EnumValueOptions {
  return { hidden: false, default: false, reserve: false };
}

export const EnumValueOptions: MessageFns<EnumValueOptions> = {
  encode(message: EnumValueOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hidden !== false) {
      writer.uint32(16).bool(message.hidden);
    }
    if (message.default !== false) {
      writer.uint32(24).bool(message.default);
    }
    if (message.reserve !== false) {
      writer.uint32(32).bool(message.reserve);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnumValueOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumValueOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.default = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.reserve = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnumValueOptions {
    return {
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
      default: isSet(object.default) ? globalThis.Boolean(object.default) : false,
      reserve: isSet(object.reserve) ? globalThis.Boolean(object.reserve) : false,
    };
  },

  toJSON(message: EnumValueOptions): unknown {
    const obj: any = {};
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    if (message.default !== false) {
      obj.default = message.default;
    }
    if (message.reserve !== false) {
      obj.reserve = message.reserve;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnumValueOptions>, I>>(base?: I): EnumValueOptions {
    return EnumValueOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnumValueOptions>, I>>(object: I): EnumValueOptions {
    const message = createBaseEnumValueOptions();
    message.hidden = object.hidden ?? false;
    message.default = object.default ?? false;
    message.reserve = object.reserve ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
